module.exports = __webpack_public_path__ + "static/media/frontend development icon.69346dac.svg";